import { defineComponent, ref, onMounted, onBeforeUnmount, computed } from 'vue';
export default defineComponent({
  props: {
    showTitle: {
      default: true
    },
    showBody: {
      default: true
    },
    closeOnEsc: {
      default: true
    },
    unmountOnClose: {
      default: false
    }
  },
  emits: ['open', 'close'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var show = ref(false);

    var close = function close() {
      show.value = false;
      emit('close');
    };

    var open = function open() {
      show.value = true;
      emit('open');
    };

    var keyDownEsc = function keyDownEsc() {
      if (props.closeOnEsc) {
        close();
      }
    };

    var key = computed(function () {
      return props.unmountOnClose ? show.value : 1;
    });
    onMounted(function () {
      document.addEventListener('keydown', function (e) {
        if (show.value && e.keyCode === 27) {
          keyDownEsc();
        }
      });
    });
    onBeforeUnmount(function () {
      window.removeEventListener('keydown', keyDownEsc);
    });
    return {
      show: show,
      close: close,
      open: open,
      key: key
    };
  }
});